var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#000",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.998 8.706l-2.791 2.792-.707-.707L7.29 7.999l-2.79-2.79.707-.707 2.79 2.79L10.79 4.5l.708.707L8.704 8l2.794 2.794-.707.707-2.794-2.794z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMTYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03Ljk5ODIzIDguNzA2NDJMNS4yMDY4NiAxMS40OTc4TDQuNDk5NzYgMTAuNzkwN0w3LjI5MTEyIDcuOTk5MzFMNC41MDA4OCA1LjIwOTA2TDUuMjA3OTkgNC41MDE5NUw3Ljk5ODIzIDcuMjkyMkwxMC43OTA0IDQuNUwxMS40OTc1IDUuMjA3MTFMOC43MDUzNCA3Ljk5OTMxTDExLjQ5ODcgMTAuNzkyNkwxMC43OTE2IDExLjQ5OTdMNy45OTgyMyA4LjcwNjQyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgCloseBtn as ReactComponent };